// src/api/modules/PickupApi.js
import Methods from "../methods";
import dateformat from 'dateformat'
import {formatDate} from "../../util/date-util";

const searchPickups = (context, payload) => {
  const {filters, page, size, sortBy = "pickupDate", direction = "desc"} = payload;
  const url = `api/pickups/search/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;

  return Methods.doPost(context, url, filters, null);
};

const loadReportForPickup = (context, payload) => {
  const url = `report/pickups/${payload.pickup.id}?${payload.params}`
  if (payload.params === "resume=true") {
    return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `reporte-resumen-recojo-${payload.nameClient}-${dateformat(payload.pickup.pickupDate, "dd-mm-yyyy")}`, null)
  } else {
    return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `reporte-recojo-${payload.nameClient}-${dateformat(payload.pickup.pickupDate, "dd-mm-yyyy")}`, null)
  }
}

const loadReportForPickupGuia = (context, payload) => {
  const url = `report/pickups/guia/${payload.pickup.id}`
  return Methods.doPostDonwload(context, url, {extExport: 'pdf'}, `guia-recojo-${payload.nameClient}-${dateformat(payload.pickup.pickupDate, "dd-mm-yyyy")}`, null)
}

const loadPickupListWithFilters = (context, payload) => {
  const url = `api/pickups-filters?${payload.params}`
  return Methods.doGet(context, url, null)
}

const registerPickup = (context, payload) => {
  const url = `api/pickups/save`;
  return Methods.doPost(context, url, payload);
};

const confirmPickup = (context, idPickup, request) => {
  const url = `api/pickups/${idPickup}/confirm`
  return Methods.doPatch(context, url, request, null)
}

const updatePickupDate = (context, payload) => {
  const url = `api/pickups/${payload.idPickup}/pickup-date`;
  return Methods.doPatch(context, url, payload);
};

const exportPickupsExcel = (context, filters) => {
  const url = `report/pickups/export-excel`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_recojos_${newDate}.xlsx`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const exportPickupsPdf = (context, filters) => {
  const url = `report/pickups/export-pdf`;
  const newDate = formatDate(new Date());
  const fileName = `Reporte_recojos_${newDate}.pdf`;

  return Methods.doPostDonwload(context, url, filters, fileName, null);
};

const downloadVaultPickupOrderPdf = (context, id) => {
  const url = `report/pickups/${id}/vault`;
  const newDate = formatDate(new Date());
  const fileName = `Orden_recojo` + "_" + newDate + ".pdf";

  return Methods.doPostDonwload(context, url, {}, fileName, null);
};

export default {
  searchPickups,
  loadReportForPickup,
  loadReportForPickupGuia,
  loadPickupListWithFilters,
  registerPickup,
  confirmPickup,
  updatePickupDate,
  exportPickupsExcel,
  exportPickupsPdf,
  downloadVaultPickupOrderPdf,
}



// WEBPACK FOOTER //
// ./src/api/modules/PickupApi.js